import { render } from "./PpcBidSimulator.vue?vue&type=template&id=6e793f2f&scoped=true"
import script from "./PpcBidSimulator.vue?vue&type=script&lang=js"
export * from "./PpcBidSimulator.vue?vue&type=script&lang=js"

import "./PpcBidSimulator.vue?vue&type=style&index=0&id=6e793f2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e793f2f"]])

export default __exports__